export function isEmpty(obj: any): boolean {
  if (typeof obj === 'undefined') {
    return true;
  }

  return Object.entries(obj).length === 0;
}
